import { AreaAPI } from "../api";
import moment from "moment";
export class Area {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }

  get statusBooking() {
    let res = { text: '', icon: '', title: "", subTitle: "", color: '', isAvailable: false, isUnavailable: false, isSuspend: false, isInContract: false, isOutContract: false, }
    res.text = `${this.name}`
    res.title = `${this.name}`
    if (this.contract && this.contract.isSuspend) {
      res.text += ' (อยู่ระหว่างพักแผงค้า) '
      res.title += ' (อยู่ระหว่างพักแผงค้า) '
      res.color = 'warning'
      res.isSuspend = true
    }
    if (this.contract && this.contract.endDate) {
      res.text += ' มีผู้เช่ารายเดือน'
      res.subTitle += ' มีผู้เช่ารายเดือน'
      res.isUnavailable = true
      if (checkExpired(this.contract.endDate)) {
        res.text += ' หมดสัญญา'
        res.subTitle += ' หมดสัญญา'
        res.icon = 'mdi-alert-circle-outline'
        res.color = 'info'
        res.isOutContract = true
      } else {
        res.text += ' อยู่ในสัญญา'
        res.subTitle += ' อยู่ในสัญญา'
        res.icon = 'mdi-account-supervisor-circle'
        res.color = 'error'
        res.isInContract = true
      }
      res.text += `(${moment(this.contract.endDate.iso).format('DD/MM/YYYY')})`
      res.subTitle += `(${moment(this.contract.endDate.iso).format('DD/MM/YYYY')})`
    } else if (this.contract && !this.contract.endDate) {
      res.icon = 'mdi-close-circle-outline'
      res.color = 'error'
    } else {
      res.text += ' แผงว่าง'
      res.title += ' แผงว่าง'
      res.icon = 'mdi-storefront-outline'
      res.color = 'success'
      res.isAvailable = true
    }
    if (this.contract && this.contract.isSuspend) {
      res.icon = 'mdi-pause-circle-outline'
      res.color = 'warning'
    }
    return res
  }
  
  static async getAvailableAreas(payload) {
    const { data } = await AreaAPI.getAvailableAreas(payload);
    return data.result.map(item => new Area(item));
  }
}

function checkExpired(date) {
  let isExpired = false;
  if (date && date.iso) {
    isExpired = moment().isAfter(moment(date.iso));
  } else if (date) {
    isExpired = moment().isAfter(moment(date));
  }
  return isExpired;
}